import { useState, useCallback } from 'react';
import { useConfigStore } from '../store/config-store';
import { NumPad } from './NumPad';

interface AdminLoginDialogProps {
  onSuccess: () => void;
  onCancel: () => void;
}

export function AdminLoginDialog({ onSuccess, onCancel }: AdminLoginDialogProps) {
  const adminPin = useConfigStore((s) => s.adminPin);
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = useCallback(() => {
    if (pin === adminPin) {
      onSuccess();
      return;
    }

    setError(true);
    setTimeout(() => {
      setError(false);
      setPin('');
    }, 1500);
  }, [pin, adminPin, onSuccess]);

  return (
    <div className="overlay">
      <div
        className={`bg-surface-card rounded-3xl p-8 w-[420px] max-w-[90vw] flex flex-col items-center gap-6 animate-fade-in ${
          error ? 'animate-shake' : ''
        }`}
      >
        {/* Lock icon */}
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" className="text-accent">
          <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
          <path
            d="M8 11V7a4 4 0 1 1 8 0v4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="12" cy="16" r="1.5" fill="currentColor" />
        </svg>

        <h2 className="text-2xl font-bold text-white">Administration</h2>

        {error && (
          <p className="text-danger font-semibold text-sm">Code incorrect</p>
        )}

        <NumPad
          value={pin}
          onChange={setPin}
          onSubmit={handleSubmit}
          maxLength={6}
          masked
          placeholder="Code PIN"
        />

        <button
          type="button"
          className="text-white/50 text-sm underline underline-offset-2 mt-2"
          onClick={onCancel}
        >
          Annuler
        </button>
      </div>
    </div>
  );
}
